import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaCheckCircle, FaEye, FaEyeSlash } from 'react-icons/fa';
import { API_BASE_URL } from '../config';
import { startSession } from '../session';
import logo from '../assets/fortunehomecare-logo.png';

const Login = ({ onSignedIn }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (event) => {
    event.preventDefault();
    setError('');
    setBusy(true);
    try {
      const response = await fetch(`${API_BASE_URL}/vendor/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ company_email: email.trim(), password }),
      });
      const result = await response.json();
      if (response.ok) {
        startSession(result.vendor, result.token);
        onSignedIn(result.vendor);
        navigate('/audits', { replace: true });
      } else {
        setError(result.error || 'Those details did not match a vendor account.');
      }
    } catch {
      setError('Could not reach the server. Check your connection and try again.');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="auth">
      <div className="auth-art">
        <div className="mark"><img src={logo} alt="Fortune Home Care" /></div>
        <div>
          <h2>Your jobs, your team, one dashboard.</h2>
          <p>Accept new audits and bookings from Fortune Home Care and send the right technician to every job.</p>
          <ul>
            <li><FaCheckCircle /> Accept or decline new work</li>
            <li><FaCheckCircle /> Assign verified field staff</li>
            <li><FaCheckCircle /> Onboard technicians with their documents</li>
          </ul>
        </div>
        <div className="foot">Fortune Home Care · Vendor partner portal</div>
      </div>
      <div className="auth-form-side">
        <div className="auth-form">
          <img src={logo} alt="Fortune Home Care" className="mobile-logo" />
          <h1>Vendor sign in</h1>
          <p className="lead">Use the company email registered with Fortune Home Care.</p>
          <form className="form" onSubmit={handleLogin}>
            {error && <div className="alert alert-error">{error}</div>}
            <div className="field">
              <label htmlFor="email">Company email</label>
              <input id="email" className="input" type="email" autoComplete="username" placeholder="you@company.com"
                value={email} onChange={(e) => setEmail(e.target.value)} required autoFocus />
            </div>
            <div className="field">
              <label htmlFor="password">Password</label>
              <div className="password-field">
                <input id="password" className="input" type={showPassword ? 'text' : 'password'} autoComplete="current-password"
                  placeholder="Enter your password" value={password} onChange={(e) => setPassword(e.target.value)} required />
                <button type="button" className="icon-btn" onClick={() => setShowPassword((v) => !v)}
                  aria-label={showPassword ? 'Hide password' : 'Show password'}>
                  {showPassword ? <FaEyeSlash /> : <FaEye />}
                </button>
              </div>
            </div>
            <button type="submit" className="btn btn-primary btn-block" disabled={busy}>
              {busy ? <span className="spinner sm" style={{ borderTopColor: '#fff' }} /> : 'Sign in'}
            </button>
          </form>
          <p className="fine">Forgot your password? Contact Fortune Home Care operations.</p>
        </div>
      </div>
    </div>
  );
};

export default Login;
